import React from 'react';
import {formatCurrency} from './PublicLineItems';

function PublicOptionalExtras({
  items,
  selectedExtraIds,
  onToggle,
  disabled=false
}) {
  if (!items?.length) {
    return null;
  }

  return (
    <section className="proposal-section">
      <div className="proposal-heading">
        <h2>Optional Additional Deliverables</h2>
        <p>
          {disabled
            ? 'Accepted optional deliverables'
            : 'Select any additions you would like included.'}
        </p>
      </div>
      <div className="client-options">
        {items.map((item,index)=> {
          const itemId=String(item.id);
          const selected=selectedExtraIds.includes(itemId);

          return (
            <label
              className={`client-option ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
              key={item.id || `${item.name}-${index}`}
            >
              <input
                checked={selected}
                disabled={disabled}
                onChange={()=> onToggle(itemId)}
                type="checkbox"
              />
              <span>{item.name}</span>
              <strong>+{formatCurrency(item.price_cents)}</strong>
            </label>
          );
        })}
      </div>
    </section>
  );
}

export default PublicOptionalExtras;